import React from "react";
import "./Schedules.css";
import Wrapper from "../components/basic/wrapper";
import SafeArea from "../components/basic/safe-area";
import { MovieSVG, TheaterSVG } from "../constants/svgs";
import Networks from "../components/basic/social-networks-row/Networks";
import { useI18n } from "../i18n/i18n";

const Schedules: React.FC = () => {
    const sectionColor = "#000000";
    const sectionTextColor = "#000000";

    const { lang, t, d } = useI18n();
    const events = d.schedules.events;

    const renderIcon = (kind: "theatre" | "film") =>
        kind === "film" ? <MovieSVG /> : <TheaterSVG />;

    return (
        <Wrapper
            color={sectionColor}
            footerColor={sectionTextColor}
            logoColor={sectionTextColor}
        >
            <div
                style={{ backgroundColor: sectionColor }}
                className="schedules-wrapper"
            >
                <SafeArea>
                    <div className="fs48 fw900 mb25 schedules-title">{t("schedules.title")}</div>
                </SafeArea>

                {/* Desktop layout */}
                <div className="schedules-desktop">
                    <SafeArea>
                        <div className="schedules-list-desktop">
                            {events.map((event) => (
                                <div key={event.id} className="schedule-row-desktop gap">
                                    <div className="schedule-col-venue">
                                        <div className="schedule-venue-title">
                                            {event.venueTitle[lang]}
                                        </div>
                                    </div>

                                    <div className="schedule-col-type gap">
                                        {renderIcon(event.kind)}
                                        <span className="schedule-type-label fw700">
                                            {event.typeLabel[lang]}
                                        </span>
                                    </div>

                                    <div />

                                    <div className="schedule-col-date fw700">{event.date[lang]}</div>

                                    <div className="schedule-col-link tar">
                                        <a
                                            href={event.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {event.urlLabel[lang]}
                                        </a>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </SafeArea>
                </div>

                {/* Mobile layout */}
                <div className="schedules-mobile">
                    <SafeArea>
                        <div className="schedules-list-mobile">
                            {events.map((event) => (
                                <div key={event.id} className="schedule-row-mobile">
                                    <div className="schedule-venue-title">
                                        {event.venueTitle[lang]}
                                    </div>

                                    <div className="schedule-mobile-meta">
                                        <div className="schedule-col-type">
                                            {renderIcon(event.kind)}
                                            <span className="schedule-type-label fw700">
                                                {event.typeLabel[lang]}
                                            </span>
                                        </div>
                                        <div className="schedule-col-date fw700">{event.date[lang]}</div>
                                    </div>

                                    <div className="schedule-col-link schedule-col-link-mobile">
                                        <a
                                            href={event.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {event.urlLabel[lang]}
                                        </a>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </SafeArea>
                </div>

                <div style={{ height: 60 }} />
                <SafeArea>
                    <Networks scrollTargetId="-1" />
                </SafeArea>
                <div style={{ height: 60 }} />
            </div>
        </Wrapper>
    );
};

export default Schedules;
